import AssetService from '../../../../shared/services/AssetService';
import DefaultImage from '../../../images/default-image.jpg';
import Grid from '@mui/material/Unstable_Grid2';
import { ListComponent } from '../../../models/LessonComponent';
import { ListType } from '../../../models/LessonComponentSettings';
import React from 'react';
import { RgbaColor } from '../../../models/LessonComponentStyle';
import { getColorString } from '../../../services/StyleService';
import styles from '../../../styles/List.module.scss';
import { useTheme } from '@mui/material';

interface ListNumberProps {
  component: ListComponent;
  sequenceNumber: number;
}

export const ListNumber = (props: ListNumberProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const { settings } = props.component;
  const displayMode: ListType = settings.listSettings?.listType;
  const backgroundColor: RgbaColor = settings.listSettings?.backgroundColor;
  const foregroundColor: RgbaColor = settings.listSettings?.foregroundColor;

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: ['numbered', 'icon'].includes(displayMode)
          ? ''
          : backgroundColor
          ? getColorString(backgroundColor)
          : primaryColor
      }}
      className={styles[displayMode]}
    >
      {displayMode === 'icon' ? (
        <img
          src={AssetService.getAssetUrl(settings.assetkey) || DefaultImage}
          className={styles.iconStyle}
        />
      ) : (
        displayMode !== 'bulleted' && (
          <Grid
            className={`${styles.number} ${styles[`number_${displayMode}`]}`}
          >
            <span
              style={{
                color: foregroundColor ? getColorString(foregroundColor) : ''
              }}
            >
              {props.sequenceNumber}
            </span>
          </Grid>
        )
      )}
    </Grid>
  );
};
